import { Button } from '@mui/material';
import { JSXElementConstructor, ReactElement } from 'react';

export const DrawerButton = ({
  text,
  onClick,
  isDisabled,
  color,
  backgroundColor,
  variant = 'contained',
  dataTestId = 'drawer-activate',
}: {
  text: string | ReactElement<any, string | JSXElementConstructor<any>>;
  onClick?: (
    _: React.MouseEvent<HTMLButtonElement> | undefined,
    confirmed?: boolean | undefined
  ) => void;
  isDisabled: boolean;
  color?:
    | 'primary'
    | 'inherit'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | undefined;
  backgroundColor?: string;
  variant: 'outlined' | 'contained';
  dataTestId?: string;
}) => {
  return (
    <Button
      data-testid={dataTestId}
      type="button"
      variant={variant}
      disabled={isDisabled}
      onClick={onClick}
      color={color}
      sx={{
        fontWeight: '700',
        lineHeight: '1.3750em',
        letterSpacing: '0.029em',
        backgroundColor: backgroundColor,
      }}
    >
      {text}
    </Button>
  );
};
